<template>
  <div :class="classnames" @click="handleClick">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'
  import { EventBus } from '@/utils/eventBus.js'

  const namespace = 'open-modal-control'

  export default {
    name: 'OpenModalControl',
    mixins: [ bem ],
    props: {
      props: {
        type: Object
      },
      view: {
        type: String
      }
    },
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleClick: function () {
        const {
          view,
          props
        } = this

        EventBus.$emit('openmodal', view, props)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/OpenModalControl.vue